export function initStonesDialog() {
  const dialog = document.getElementById('stonesDialog');
  if (!dialog) return;

  document.querySelectorAll('[data-stones-popup]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });
  });

  dialog.querySelectorAll('[data-stones-close]').forEach((btn) => {
    btn.addEventListener('click', () => dialog.close());
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    dialog.close();
  });
}
